import { Wines } from '../../Wines/Wines';
import { RefObject } from 'react';
import { WineModel, WineWidgetModel } from '../../../models/WineWidgetModel';
import { v4 as uuidv4 } from 'uuid';

interface WinesContentWithScrollbarProps {
  scrollbarRef: RefObject<HTMLDivElement>;
  isScrollbarVisible: boolean;
  scrollbarColor: string;
  item: WineModel;
  wineList: WineWidgetModel[];
}

/**
 * WinesContentWithScrollbar component
 * @param scrollbarRef - scrollbar reference
 * @param isScrollbarVisible - is scrollbar visible
 * @param scrollbarColor - scrollbar color
 * @param item - wine model
 * @param wineList - list of wines
 * @returns - WinesContentWithScrollbar component
 */

const WinesContentWithScrollbar = ({ scrollbarRef, isScrollbarVisible, scrollbarColor, item, wineList }: WinesContentWithScrollbarProps) => {
  // Generate a unique scrollbar class name
  const scrollbarId = uuidv4();
  const uniqueScrollbarClassName = `CustomScrollbar${scrollbarId}`;

  // Dynamic style for the scrollbar
  const dynamicStyle = `
  /* Chrome custom scrollbar */
    .${uniqueScrollbarClassName}::-webkit-scrollbar {
      width: 12px; !important;
      height: 12px !important;
    }
    .${uniqueScrollbarClassName}::-webkit-scrollbar-track {
      background: #f2f2f2; !important;
      border-radius: 8px; !important;
    }
    .${uniqueScrollbarClassName}::-webkit-scrollbar-thumb {
      background: ${scrollbarColor}; !important;
      border-radius: 8px; !important;
    }
    .${uniqueScrollbarClassName}::-webkit-scrollbar-thumb:hover {
      background: ${scrollbarColor}; !important;
    }

    /* Firefox custom scrollbar */
    @-moz-document url-prefix() {
    .${uniqueScrollbarClassName} {
      scrollbar-width: 16px !important;
      scrollbar-color: ${scrollbarColor} #f2f2f2 !important;
    }
    .${uniqueScrollbarClassName} {
      border-radius: 8px !important; 
    }
}
`;

  return (
    <div ref={scrollbarRef} className={`${uniqueScrollbarClassName} flex w-full overflow-x-auto py-2 ${isScrollbarVisible ? 'min-[350px]:mb-2 md:mb-5' : 'mb-0'}`}>
      <style>{dynamicStyle}</style>
      <Wines item={item} wineList={wineList} />
    </div>
  );
};

export default WinesContentWithScrollbar;
